import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ssn' })
export class SSNPipe implements PipeTransform {
    transform(str: string): string {

      let ssn1, ssn2, ssn3;

	    str = str.replace(/[^\d]/g, '');

	    ssn1 = str.match(/^\d{1,3}/);
	    ssn2 = str.match(/^\d{3}-?(\d{1,2})/);
	    ssn3 = str.match(/^\d{3}-?\d{2}-?(\d{1,4})/);

	    ssn1 = ssn1 ? ssn1[0] : '';
	    ssn2 = ssn2 ? ssn2[1] : '';
	    ssn3 = ssn3 ? ssn3[1] : '';

	    if (ssn3 && ssn3.length === 4) {
	      str = 'xxx-xx-' + ssn3;
	    } else if (ssn3) {
	      str = ssn1 + '-' + ssn2 + '-' + ssn3;
	    } else if (ssn2) {
	      str = ssn1 + '-' + ssn2;
	    } else {
	      str = ssn1 || '';
	    }

	    return str;
    }
}
